import { Typography } from "@mui/material";

import { CHART_BASIS } from "@lopie/kernel-ui/components/Chart";

/**
 * What a figure or a table counts, said beside it.
 *
 * `Chart` carries this sentence itself. A figure and a table are not charts and
 * would otherwise carry nothing, and a number with no sentence is the one that
 * gets quoted as everyone's. It is the same sentence, from the same place, so
 * the three cannot drift into three stories.
 *
 * It says what is counted and when the copy is as of, and the kernel's own reason
 * for that time is one hover away. It never says that anything was left out.
 */
export default function Basis({ asOf, why }) {
  const stamp = asOf ? new Date(asOf) : null;
  const valid = stamp && !Number.isNaN(stamp.getTime());
  return (
    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
      {CHART_BASIS}
      {valid ? (
        <>
          {" "}
          As of <time dateTime={stamp.toISOString()} title={why || undefined}>{stamp.toLocaleString()}</time>.
        </>
      ) : null}
    </Typography>
  );
}
